/** Build user-visible copy for a failed template share; optional org-tab hint for membership errors. */
export function formatTemplateShareErrorMessage(
  error: unknown,
  templateName: string,
  subjectName: string,
  isOrgScopedSearch: boolean,
): string {
  const detail = error instanceof Error ? error.message : String(error);
  let message = `Failed to share "${templateName}" with ${subjectName}. ${detail}`;
  if (isOrgScopedSearch && /not a member of the account/i.test(detail)) {
    message +=
      " Template shares require the person to be a member of this workspace.";
  }
  return message;
}
